const routes = {
  login: {
    root: "/login",
  },
  upload: {
    upload: "/upload",
  },
    download: {
    download: "/download",
  },
  homePage: {
    homePage: "/homePage",
  },
  customerOrders: {
    customerOrders: "/customerOrders",
  },
  orderDetails: {
    orderDetails: "/orderDetails",
  },
};

export default routes;
